import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dialog } from 'primereact/dialog'
import { InputSwitch } from 'primereact/inputswitch'
import React from 'react'
import LancarFechamentoBancarioService from '../../app/service/conciliacaoBancaria/lancarFechamentoBancarioService'
import TransferenciaBancaraiService from '../../app/service/conciliacaoBancaria/transferenciaBancaraiService'
import GeneralServices from '../../app/service/generalServices'
import HandleErrorService from '../../app/service/handleErrorService'
import ConstantsUtil from '../../context/constantsUtil'
import * as popUp from '../toastr'
import * as xlsx from 'xlsx'
import CancelLancamentoBancarioButton from './cancelLancamentoBancarioButton'
import EditLancamentoBancarioButton from './editLancamentoBancarioButton'
import EditLancamentoBancarioDialog from './editLancamentoBancarioDialog'
import TableFilters from '../tableFilters'
import AuthService from '../../app/service/authService'
import VisualizarDanfeButton from '../nf/visualizarDanfeButton'
import AuditoriaService from '../../app/service/auditoriaService'

class FichaBancariaTable extends React.Component {

    constructor(){
        super()
        this.dt = React.createRef()
        this.tableFilters = new TableFilters();
        this.lancarFechamentoBancarioService = new LancarFechamentoBancarioService();
        this.transferenciaBancaraiService = new TransferenciaBancaraiService();
        this.auditoriaService = new AuditoriaService();
        // this.contaBancariaService = new ContaBancariaService()
    }

    state = {

        editLancamentoBancarioDialog: false,
        editLancamentoBancarioDialogHeader: "Editar Lançamento",

        displayDeleteConfirmation: false,

        lancamentoToEdit: null,
        lancamentoToDelete: null,

        filteredList: '',

        loading: false,

        selectedLancamentosBancarios: [],
        edicaoEmLote: false,
        exclusaoEmLoteAtiva: false,
        exibirLancamentosExcluidos: false,
        auditoriaDialog: false,
        auditoriaList: [],
        auditoriaIndexesExpandidos: []


    }

    hideDialog = () => {
        this.setState({
            editLancamentoBancarioDialog: false,
            edicaoEmLote: false
        })
    }

    getTableHeaders = () => {
        //Para não mostrar "undefined" no header enquanto o backend está processando a requisição
        var contaBancaria = ""
        var label = ""
        if(this.props.fichaBancaria && this.props.fichaBancaria.contaBancaria){
            contaBancaria = this.props.fichaBancaria.contaBancaria.formattedName ? this.props.fichaBancaria.contaBancaria.formattedName : ""
            label = "Conta Bancária: "
        }
        else if(this.props.fichaBancaria && this.props.fichaBancaria.aplicacaoFinanceira){
            contaBancaria = this.props.fichaBancaria.aplicacaoFinanceira
            label = "Aplicação Financeira: "
        }

        const contaBancariaLabel =  label + contaBancaria
        
        const periodo = this.props.fichaBancaria && this.props.fichaBancaria.initialDate ? this.props.fichaBancaria.initialDate + " - " + this.props.fichaBancaria.finalDate : ""
        const periodoLabel = "Período: " + periodo

        return {contaBancaria: contaBancariaLabel, periodo: periodoLabel}
    }

    callDelete = (lancamento) => {

        if(this.state.selectedLancamentosBancarios && this.state.selectedLancamentosBancarios.length > 1){
            popUp.infoPopUp("Você selecionou mais de um lançamento bancário. Utilize a opção em lote acima")
            return;
        }        

        if(this.verificaPossuiContaBancaria(lancamento)){
            this.setState({exclusaoEmLoteAtiva: false})
            this.setState({lancamentoToDelete: lancamento})
            this.setState({displayDeleteConfirmation: true})
        }
    }

    cancelDelete = () => {
        this.setState({lancamentoToDelete: null})
        this.setState({exclusaoEmLoteAtiva: false})
        this.setState({displayDeleteConfirmation: false})
    }

    showAuditoriaLancamentoBancario = (lancamento) => {
        if(!lancamento.idLancamentoFechamentoBancario){
            return
        }

        this.setState({loading: true})
        this.auditoriaService.findAllByLancamentoBancario(lancamento.idLancamentoFechamentoBancario)
            .then(response => {
                this.setState({
                    auditoriaList: response.data,
                    auditoriaDialog: true,
                    //Começa a timeline toda fechada, só com o cabeçalho
                    auditoriaIndexesExpandidos: []
                })
            })
            .catch(error => HandleErrorService.handleError(error))
            .finally(() => this.setState({loading: false}))
    }

    toggleAuditoriaItemExpandido = (index) => {
        const indexesExpandidos = this.state.auditoriaIndexesExpandidos.slice()
        const posicaoDoIndex = indexesExpandidos.indexOf(index)

        if(posicaoDoIndex === -1){
            indexesExpandidos.push(index)
        }
        else{
            indexesExpandidos.splice(posicaoDoIndex, 1)
        }

        this.setState({auditoriaIndexesExpandidos: indexesExpandidos})
    }

    formatAuditoriaDataHora = (dataHora) => {
        if(!dataHora || !dataHora.includes('T')){
            return dataHora
        }

        const [datePart, timePart] = dataHora.split('T')
        const [year, month, day] = datePart.split('-')
        const hourAndMinute = timePart.substring(0, 5)

        return `${day}-${month}-${year} ${hourAndMinute}`
    }

    getAuditoriaAcaoLabel = (tipoAcao) => {
        switch(tipoAcao){

            case 'CRIACAO':
                return 'Criação'
            case 'EDICAO':
                return 'Alteração'
            case 'EXCLUSAO':
                return 'Exclusão'
            default:
                return 'Ação não identificada'

        }
    }

    getAuditoriaAlteracoesTotal = () => {
        return this.state.auditoriaList.reduce((total, auditoria) => {
            return total + (auditoria.alteracoes ? auditoria.alteracoes.length : 0)
        }, 0)
    }

    renderAuditoriaValor = (valor, isValorNovo, isExclusao) => {
        const naoInformado = !valor || valor === '-'
        const backgroundColor = isValorNovo && !isExclusao ? '#e9f8f0' : '#f8fafc'
        const color = isExclusao ? '#d32f2f' : isValorNovo ? '#145c45' : '#495464'

        return (
            <div
                style={{
                    backgroundColor,
                    color,
                    borderRadius: '4px',
                    padding: '14px 16px',
                    minHeight: '72px',
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: naoInformado ? 'normal' : 'bold',
                    fontStyle: naoInformado ? 'italic' : 'normal'
                }}
            >
                {naoInformado ? 'Não informado' : valor}
            </div>
        )
    }

    renderAuditoriaItem = (auditoria, index) => {
        const isExclusao = auditoria.tipoAcao === 'EXCLUSAO'
        const alteracoes = auditoria.alteracoes || []
        const estaExpandido = this.state.auditoriaIndexesExpandidos.indexOf(index) !== -1

        return (
            <div key={index} style={{display: 'flex', gap: '18px', position: 'relative'}}>
                <div style={{width: '28px', display: 'flex', justifyContent: 'center', position: 'relative'}}>
                    <div
                        style={{
                            width: '2px',
                            backgroundColor: '#c8d6e5',
                            position: 'absolute',
                            top: 0,
                            bottom: index === this.state.auditoriaList.length - 1 ? '38px' : '-22px'
                        }}
                    />
                    <div
                        style={{
                            width: '14px',
                            height: '14px',
                            borderRadius: '50%',
                            marginTop: '20px',
                            backgroundColor: index === 0 ? '#1976d2' : '#ffffff',
                            border: index === 0 ? '2px solid #1976d2' : '2px solid #9fb6cc',
                            zIndex: 1
                        }}
                    />
                </div>

                <div
                    style={{
                        flex: 1,
                        border: '1px solid #d7e4f1',
                        borderRadius: '6px',
                        marginBottom: '22px',
                        overflow: 'hidden'
                    }}
                >
                    <div
                        style={{display: 'flex', alignItems: 'center', gap: '16px', padding: '12px 18px', borderBottom: estaExpandido ? '1px solid #e6edf5' : 'none', cursor: 'pointer'}}
                        onClick={() => this.toggleAuditoriaItemExpandido(index)}
                    >
                        <span
                            style={{
                                backgroundColor: isExclusao ? '#fdeaea' : '#d8ecff',
                                color: isExclusao ? '#d32f2f' : '#1976d2',
                                borderRadius: '18px',
                                padding: '6px 14px',
                                fontWeight: 'bold'
                            }}
                        >
                            {this.getAuditoriaAcaoLabel(auditoria.tipoAcao)}
                        </span>
                        <span style={{fontWeight: 'bold'}}>{this.formatAuditoriaDataHora(auditoria.dataHora)}</span>
                        <span style={{color: '#6c757d'}}>|</span>
                        <i className="pi pi-user" style={{color: '#6c757d'}} />
                        <span style={{color: '#5f6f80'}}>{auditoria.emailUsuario}</span>

                        {/* Seta para expandir/recolher os detalhes da alteração, empurrada para o final da linha */}
                        <i
                            className={estaExpandido ? 'pi pi-chevron-down' : 'pi pi-chevron-right'}
                            style={{color: '#6c757d', marginLeft: 'auto'}}
                        />
                    </div>

                    {estaExpandido && alteracoes.map((alteracao, alteracaoIndex) => (
                        <div
                            key={alteracaoIndex}
                            style={{
                                display: 'grid',
                                gridTemplateColumns: '220px 1fr 1fr',
                                gap: '12px',
                                padding: '12px 18px',
                                borderBottom: alteracaoIndex === alteracoes.length - 1 ? 'none' : '1px solid #eef2f6'
                            }}
                        >
                            <div style={{fontWeight: 'bold', display: 'flex', alignItems: 'center'}}>
                                {alteracao.campo}
                            </div>
                            {this.renderAuditoriaValor(alteracao.valorAntigo, false, isExclusao)}
                            {this.renderAuditoriaValor(alteracao.valorNovo, true, isExclusao)}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    renderAuditoriaDialogFooter = () => {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <span style={{color: '#495464'}}>Exibindo {this.getAuditoriaAlteracoesTotal()} alterações</span>
                <Button
                    label="Fechar"
                    className="p-button-secondary"
                    onClick={() => this.setState({auditoriaDialog: false, auditoriaList: []})}
                />
            </div>
        )
    }

    renderAuditoriaTimeline = () => {
        return (
            <div>
                <p style={{color: '#5f6f80', marginTop: 0, marginBottom: '22px'}}>
                    Veja todas as alterações realizadas neste registro, com o usuário, data e os valores antes e depois.
                </p>

                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '220px 1fr 1fr',
                        backgroundColor: '#f8fafc',
                        border: '1px solid #e3e9f0',
                        borderRadius: '6px',
                        padding: '14px 18px',
                        marginBottom: '16px',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}
                >
                    <div>Campo</div>
                    <div>Antes</div>
                    <div>Depois</div>
                </div>

                {this.state.auditoriaList.map((auditoria, index) => this.renderAuditoriaItem(auditoria, index))}
            </div>
        )
    }

    deleteLancamentoOuTransferencia = () => {
        if(this.props.fromOFX && this.state.exclusaoEmLoteAtiva){
             //PASSA A LISTA SELECIONADA NO IMPORTAÇÃO_OFX_DIALOG E CHAMA O EXCLUSÃO DE FATO
             this.props.deleteLancamentosEmLoteOFX(this.state.selectedLancamentosBancarios)
             this.setState({
                 selectedLancamentosBancarios: [],
                 exclusaoEmLoteAtiva: false,
                 displayDeleteConfirmation: false
             })

            return
        }
        if(this.props.fichaBancaria && this.state.exclusaoEmLoteAtiva){
            this.deleteLancamentosEmLoteFichaBancaria()
            return
        }
        if(this.state.lancamentoToDelete.tipoFichaBancaria === ConstantsUtil.tipoFichaBancariaTransferenciaLabel){
            this.deleteTransferenciaBancaria()
        }
        else{
            this.deleteLancamentoFechamentoBancario()
        }
    }

    deleteLancamentosEmLoteFichaBancaria = () => {
        const transferencias = this.state.selectedLancamentosBancarios.filter(lancamento =>
        lancamento.tipoFichaBancaria === ConstantsUtil.tipoFichaBancariaTransferenciaLabel
        )

        const lancamentos = this.state.selectedLancamentosBancarios.filter(lancamento =>
            lancamento.tipoFichaBancaria !== ConstantsUtil.tipoFichaBancariaTransferenciaLabel
        )

        const listaParaDeletar = lancamentos.map(lancamento => {
            return {
                idLancamento: 
                    lancamento.tipoLancamentoBancario !== ConstantsUtil.lancamentoBancarioRecebimentoAplicacaoFinanceiraLabel ?
                        lancamento.idLancamentoFechamentoBancario :
                        lancamento.idLivroDiario,

                tipoDeLancamentoBancario: lancamento.tipoLancamentoBancario
            }
        })

        const listaTransferenciasParaDeletar = transferencias.map(transferencia => {
        return {
            idLancamento: transferencia.idLancamentoFechamentoBancario
        }
        })

        const promises = []

        if(listaParaDeletar.length > 0){
            promises.push(this.lancarFechamentoBancarioService.deleteList(listaParaDeletar))
        }

        if(listaTransferenciasParaDeletar.length > 0){
            promises.push(this.transferenciaBancaraiService.deleteList(listaTransferenciasParaDeletar))
        }
     
        this.beginLoadingFichaBancariaTable()
     
        Promise.all(promises)
        .then(response => {
            popUp.successPopUp("Lançamentos deletados com sucesso!")
            this.setState({
                selectedLancamentosBancarios: [],
                exclusaoEmLoteAtiva: false,
                displayDeleteConfirmation: false
            })
        
            if(this.props.search){
                this.props.search()
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.endLoadingFichaBancariaTable()
        })
    }

    deleteTransferenciaBancaria = () => {
        this.setState({displayDeleteConfirmation: false})
        if(this.props.fromOFX){
            this.props.deleteLancamentoOFX(this.state.lancamentoToDelete)
        }
        else{
            this.transferenciaBancaraiService.delete(
                {
                    idLancamento: this.state.lancamentoToDelete.idLancamentoFechamentoBancario 
                }
            ).then(response => {
                popUp.successPopUp("Transferência deletada com sucesso!")
                this.props.search()
            })
            .catch(error => {
                HandleErrorService.handleError(error)
            })
        }
    }

    deleteLancamentoFechamentoBancario = () => {
        if(this.props.fromOFX){
            this.props.deleteLancamentoOFX(this.state.lancamentoToDelete)
            this.setState({displayDeleteConfirmation: false})
        }
        else {
            this.deleteRealLancamentoFechamentoBancario()
        }
    }

    deleteRealLancamentoFechamentoBancario = () => {
        this.setState({displayDeleteConfirmation: false})
        this.lancarFechamentoBancarioService.delete(
            {
                idLancamento: 
                    this.state.lancamentoToDelete.tipoLancamentoBancario !== ConstantsUtil.lancamentoBancarioRecebimentoAplicacaoFinanceiraLabel ?
                        this.state.lancamentoToDelete.idLancamentoFechamentoBancario : 
                        this.state.lancamentoToDelete.idLivroDiario,
                    
                tipoDeLancamentoBancario: this.state.lancamentoToDelete.tipoLancamentoBancario
            }
        ).then(response => {
            popUp.successPopUp("Lançamento deletado com sucesso!")
            this.props.search()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
    }

    editLancamentoBancario = (lancamento) => {

        if(this.state.selectedLancamentosBancarios && this.state.selectedLancamentosBancarios.length > 1){
            popUp.infoPopUp("Você selecionou mais de um lançamento bancário. Utilize a opção em lote acima")
            return;
        }

        if(this.verificaPossuiContaBancaria(lancamento)) {
            this.setState({lancamentoToEdit: JSON.parse(JSON.stringify(lancamento))})
            this.setState({editLancamentoBancarioDialog: true})
            this.setState({edicaoEmLote: false})
        }
    }

    verificaPossuiContaBancaria = (lancamento) => {

        if(this.props.fromOFX && (!lancamento.contaBancaria || !lancamento.contaBancaria.id)){
            popUp.warningPopUp(ConstantsUtil.errorSelecioneContaBancariaMessage)
            return false;
        }

        return true

    }

    possuiLancamentoInvalidoParaLote = (listaSelecionada) => {
        return listaSelecionada.some(lancamento => {
            if(!lancamento.tipoLancamentoBancario){
                return true
            }

            if(lancamento.tipoLancamentoBancario === ConstantsUtil.lancamentoBancarioRecebimentoLabel){
                return !lancamento.idTipoDeRecebimento
            }

            if(lancamento.tipoLancamentoBancario === ConstantsUtil.lancamentoBancarioPagamentoLabel){
                return !lancamento.idTipoDePagamento
            }

            return true
        })
    }

    beginLoadingFichaBancariaTable = () => {
        this.setState({loading: true})
    }

    endLoadingFichaBancariaTable = () => {
        this.setState({loading: false})
    }

    rowClass(rowData) {
        return {
            [ConstantsUtil.totaisTableLabel]: rowData.tipoLancamentoBancario === ConstantsUtil.tipoTotaisFichaBancariaLabel,
            'lancamento-bancario-excluido': rowData.excluido
        }
    }

    exportExcel = () => {
        const periodo = this.getTableHeaders().periodo.split("Período: ")[1]
        const worksheet = this.generateWorkSheet()
        const sheetName = periodo
        const workbook = { Sheets: { [sheetName]: worksheet }, SheetNames: [[sheetName]] };
        
        
        if(this.props.DRE){
        //Ficha Bancária Dentro do DRE
            let tipo = ""

            if(this.props.diferencaDRE){
                tipo = 'Diferença'
            }
            
            else{
                tipo = this.props.DRE_RECEBIMENTO ? "Recebimento" : "Pagamento"
            }

            this.props.saveAsExcelFile(workbook, `Lançamentos DRE Mensal - ${tipo} - ${periodo} - VisãoRJ`);
        }
        else{
        //Ficha Bancária em sua tela padrão
            const contaBancaria = this.getTableHeaders().contaBancaria.split("Conta Bancária: ")[1]
            this.saveAsExcelFile(workbook, `Ficha Bancária - ${contaBancaria} - ${periodo} - VisãoRJ`);
        }

    }

    saveAsExcelFile(workbook, fileName) {
        import('file-saver').then(module => {
            if (module && module.default) {
                const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([excelBuffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + EXCEL_EXTENSION);
            }
        });
    }

    generateWorkSheet(){
        const worksheet = GeneralServices.jsonToSheet(this.formattedDREFichaBancariaToExportByExcel());
        return worksheet
    }

    formattedDREFichaBancariaToExportByExcel = () => {
        var formattedList = []

        this.props.fichaBancaria.fichaBancariaList.forEach(item =>{
            var obj = {
                Data: item.data,
                Descrição: item.descricao,
                Grupo: item.grupo,
                Histórico: item.historico
            }

            const objEntrada = {Entrada: item.entrada}
            const objSaida = {Saída: item.saida}
            const objSaldo = {Saldo: item.saldo}

            if(this.props.DRE){
                //Ficha Bancária Dentro do DRE

                if(this.props.diferencaDRE){
                    Object.assign(obj, objEntrada);
                    Object.assign(obj, objSaida);
                }

                else if(this.props.DRE_RECEBIMENTO){
                    Object.assign(obj, objEntrada);
                }
                
                else{
                    Object.assign(obj, objSaida);
                }
            }
            else{
                //Ficha Bancária em sua tela padrão
                Object.assign(obj, objEntrada);
                Object.assign(obj, objSaida);
                Object.assign(obj, objSaldo);
            }

            if(this.props.DRE){
                const contaBancariaColumn = 'Conta Bancária'
                Object.assign(obj, {[contaBancariaColumn]: item.contaBancaria.formattedName});
            }

            formattedList.push(obj)
        })

        return formattedList
    }

    getContaBancariaOrAplicacaoFinanceira = rowData => {
        let contaBancariaOuAplicacaoFinanceiraLabel = ''
        if(rowData.aplicacaoFinanceira){
            contaBancariaOuAplicacaoFinanceiraLabel = rowData.aplicacaoFinanceira.nome
        }
        else if(rowData.contaBancaria){
            contaBancariaOuAplicacaoFinanceiraLabel = rowData.contaBancaria.formattedName
        }
        else{
            /*
            Caso de transferência bancária.
            */
            contaBancariaOuAplicacaoFinanceiraLabel = rowData.descricao
        }
        rowData.contaBancariaOuAplicacaoFinanceiraLabel = contaBancariaOuAplicacaoFinanceiraLabel
    }

    getList(){
        if(this.props.fichaBancaria && this.props.fichaBancaria.fichaBancariaList){
            var list = this.props.fichaBancaria.fichaBancariaList
            if(!this.state.exibirLancamentosExcluidos){
                list = list.filter(item => !item.excluido)
            }
            list.forEach((item, index) => {
                this.getContaBancariaOrAplicacaoFinanceira(item)
                item.index = index
            }) 
            return list
        }
        return []
    }

    getTotalValue(){
        let totalValueEntrada = 0;
        let totalValueSaida = 0;
        let listToIterate = []

        if(this.state.filteredList){
            listToIterate = JSON.parse(JSON.stringify(this.state.filteredList))
        }
        else if(this.props.fichaBancaria && this.props.fichaBancaria.fichaBancariaList){
            listToIterate = JSON.parse(JSON.stringify(this.props.fichaBancaria.fichaBancariaList))
        }

        if(listToIterate.length !== 0){
            listToIterate.forEach(item => {
                // console.log("item: ", item)
                if(item.excluido){
                    return
                }
                if(item.tipoFichaBancaria !== ConstantsUtil.tipoTotaisFichaBancariaLabel && item.tipoFichaBancaria !== ConstantsUtil.tipoSaldoAnteriorFichaBancariaLabel){
                    if(item.entrada){
                        totalValueEntrada+=item.entrada
                    }
                    else if(item.saida){
                        totalValueSaida+=item.saida
                    }
                }
            })
        }

        return {
            entrada: GeneralServices.valueBodyTemplate(totalValueEntrada),
            saida: GeneralServices.valueBodyTemplate(totalValueSaida)
        };
    }

    onTableListChange = (currentTableList) => {
        // console.log("onTableListChange")
        // console.log("currentTableList: ", currentTableList)
        // console.log("this.getList(): ", this.getList())
        if(currentTableList.length === this.getList().length){
            /*
            Usuário desselecionou todos os filtros.
            */
            this.setState({filteredList: ''})
        }
        else{
            this.setState({filteredList: currentTableList})
        }
    }

    handleSelectionChange = async (e) => {

        let listaSelecionada = e.value.filter(item => !item.excluido)

        await this.setState({selectedLancamentosBancarios: listaSelecionada})

        const tiposSelecionados = listaSelecionada
                                .filter(item => item.tipoLancamentoBancario)
                                .map(item => item.tipoLancamentoBancario)

        const tiposUnicos = [...new Set(tiposSelecionados)]

        if(tiposUnicos.length > 1){
            popUp.infoPopUp("Foram selecionados lançamentos de tipos diferentes. A edição em lote não poderá ser realizada.")
        }
    } 

    exclusaoEmLote = () => {
    
        if(!this.state.selectedLancamentosBancarios || this.state.selectedLancamentosBancarios.length === 0){
            popUp.infoPopUp("Selecione ao menos 1 lançamento para exclusão em lote.")
            return
        }

        if(!this.verificaPossuiContaBancaria(this.state.selectedLancamentosBancarios[0])){
            return
        }

        if(this.possuiLancamentoInvalidoParaExclusaoEmLote(this.state.selectedLancamentosBancarios)){
            popUp.warningPopUp("Existem lançamentos selecionados que não podem ser excluídos em lote.")
            return
        }
        
        this.setState({
            exclusaoEmLoteAtiva: true,
            displayDeleteConfirmation: true
        })
    }

    possuiLancamentoInvalidoParaExclusaoEmLote = (listaSelecionada) => {
        return listaSelecionada.some(lancamento => {
            const ehTotalOuSaldo =
                lancamento.tipoFichaBancaria === ConstantsUtil.tipoTotaisFichaBancariaLabel ||
                lancamento.tipoFichaBancaria === ConstantsUtil.tipoSaldoAnteriorFichaBancariaLabel

            const naoTemIdParaExcluir =
                !lancamento.idLancamentoFechamentoBancario
                && !lancamento.idLivroDiario
                && !this.props.fromOFX

            const ehFundoFixoBloqueado =
                (this.props.fichaBancaria && this.props.fichaBancaria.fundoFixo)
                && lancamento.tipoLancamentoBancario === ConstantsUtil.lancamentoBancarioRecebimentoLabel
                && lancamento.natureza === ConstantsUtil.naturezaTipoDeRecebimentoDinheiroLabel

            // console.log("ehTotalOuSaldo: ", ehTotalOuSaldo)
            // console.log("naoTemIdParaExcluir: ", naoTemIdParaExcluir)
            // console.log("ehFundoFixoBloqueado: ", ehFundoFixoBloqueado)
            return ehTotalOuSaldo || naoTemIdParaExcluir || ehFundoFixoBloqueado
        })
    }

    editLancamentosEmLote = () => {
    
        if(!this.state.selectedLancamentosBancarios || this.state.selectedLancamentosBancarios.length === 0){
            popUp.infoPopUp("Selecione ao menos 1 lançamento para editar em lote.")
            return
        }

        if(!this.verificaPossuiContaBancaria(this.state.selectedLancamentosBancarios[0])){
            return
        }

        if(this.possuiLancamentoInvalidoParaLote(this.state.selectedLancamentosBancarios)){
            popUp.warningPopUp("Existem lançamentos selecionados que não podem ser alterados em lote.")
            return
        }


        const tiposSelecionados = this.state.selectedLancamentosBancarios
            .filter(item => item.tipoLancamentoBancario)
            .map(item => item.tipoLancamentoBancario)

        const tiposUnicos = [...new Set(tiposSelecionados)]

        if(tiposUnicos.length > 1){
            popUp.warningPopUp("Não é possível editar em lote Recebimentos e Pagamentos ao mesmo tempo.")
            return
        }

        const lancamentoBase = JSON.parse(JSON.stringify(this.state.selectedLancamentosBancarios[0]))

        this.setState({
            lancamentoToEdit: lancamentoBase,
            editLancamentoBancarioDialogHeader: "Editar Lançamentos em Lote",
            edicaoEmLote: true,
            editLancamentoBancarioDialog: true
        })
    }

    render(){

        const renderDescricaoOFXColumn = () => {
            if(this.props.fromOFX){
                return (
                    <Column
                        header="Descrição no Extrato"
                        field='descricaoOFX'
                        filter filterElement={descricaoOFXFilterElement}
                        style ={ {width: '90px'} }
                    />
                )                
            }
        }

        const renderGrupoColumn = () => {
            if(!this.props.fromOFX){
                return (
                    <Column
                        header={"Grupo"}
                        field="grupo" style ={ {width: '100px'} }
                        filter filterElement={grupoFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.grupo, rowIndex)}
                    />  
                )
            }
        }

        const renderComprovantePagamentoButton = (rowData) => {
            if(rowData.componenteDigitalComprovantePagamento && rowData.componenteDigitalComprovantePagamento.id){
                return (
                    <VisualizarDanfeButton
                        idComponenteDigital={rowData.componenteDigitalComprovantePagamento.id}
                        possuiArquivo={true}
                        tipo={ConstantsUtil.tipoComponenteDigitalComprovanteProvisaoManual}
                    />
                )
            }
        }

        const renderDescricaoColumnBody = (rowData, rowIndex) => {
            return (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <span style={{minWidth: 0, flex: 1}}>
                        {GeneralServices.renderBodyColumnInOneLine(rowData.descricao, rowIndex)}
                    </span>
                    {renderComprovantePagamentoButton(rowData)}
                </div>
            )
        }

        const renderActionColumn = () => {
            if(!this.props.disabled && !this.props.fromDRECompetencia){
                return (
                    <Column header="Ações" body={actionBody} style ={ {width: '90px'} }
                    />
                )
            }

        }

        const renderEditLancamentoBancarioButton = (lancamento) => {
            return(
                <EditLancamentoBancarioButton 
                    editLancamentoBancario = {this.editLancamentoBancario}
                    lancamento = {lancamento}
                />
            )
        }

        const renderCancelLancamentoBancarioButton = (lancamento) => {
            return(
                <CancelLancamentoBancarioButton
                    callDelete = {this.callDelete}
                    lancamento = {lancamento}
                />
            )
        }

        const actionBody = (lancamento) => {

            if(lancamento.excluido){
                return <></>
            }

            if(lancamento.fromOFX){
                return [renderEditLancamentoBancarioButton(lancamento), renderCancelLancamentoBancarioButton(lancamento)]
            }

            if(lancamento.idLancamentoFechamentoBancario) {
               
                if(
                    (this.props.fichaBancaria && this.props.fichaBancaria.fundoFixo)
                    && (lancamento.tipoLancamentoBancario === ConstantsUtil.lancamentoBancarioRecebimentoLabel)
                    && (lancamento.natureza === ConstantsUtil.naturezaTipoDeRecebimentoDinheiroLabel)
                    ){
                    /*
                    Significa recebimento de conta bancária de dinheiro (fundo fixo) de um Tipo de Recebimento com natureza DINHEIRO
                    Não pode deixar editar nem cancelar, uma vez que essas ações são feitas através 
                    do lançamento de fechamento de caixa.
                    */
                        return (
                           <></>
                        )
                        
                }
                else{
                    /*
                    Significa recebimento em fundo fixo de tipo de recebimento com natureza DIFERENTE de DINHEIRO,
                    ou pagamento de conta bancária de fundo fixo,
                    ou qualquer outro lançamento de qualquer outra conta bancária que não seja fundo fixo.
                    */
                    if(lancamento.implantacaoSaldo || (this.props.isSearchByValue && lancamento.tipoFichaBancaria === ConstantsUtil.tipoFichaBancariaTransferenciaLabel)){
                        /*
                        Se for implatanção de saldo ou (Pesquisa por Valor e Tranferência Bancáira), permite apenas cancelar.
                        */
                        return renderCancelLancamentoBancarioButton(lancamento)
                    }
                    return(
                        [renderEditLancamentoBancarioButton(lancamento), renderCancelLancamentoBancarioButton(lancamento)]
                    ) 
                }
            }
            else if(lancamento.idLivroDiario){
                return renderCancelLancamentoBancarioButton(lancamento)
            }
        }

        const renderDeleteConfirmationFooter = () => {
            return (
                <div>
                    <Button label="Confirmar" icon="pi pi-check"
                        // onClick={this.deleteLancamentoFechamentoBancario} 
                        onClick={this.deleteLancamentoOuTransferencia} 
                        autoFocus
                    />
                    <Button label="Cancelar" icon="pi pi-times" onClick={this.cancelDelete}
                            className="p-button-text" />
                </div>
            );
        }

        const renderSaldoColumn = () => {
            if(this.props.pesquisarTodasContasBancarias){
                return
            }

            if(
                this.props.fichaBancaria 
                && (!this.props.fichaBancaria.aplicacaoFinanceira && !this.props.DRE)
                && !this.props.isSearchByValue 
                && !this.props.fromOFX
            ){
                return (
                    <Column field="saldo" header="Saldo"  style ={ {width: '80px'} }
                    body = {rowData => GeneralServices.showFormattedIfNotNull(rowData.saldo, true) }
                />
                )
            }
        }

        const renderNumeroDocumentoColumn = () => {
            // if(!this.props.isSearchByValue && !this.props.fromOFX){
                return (
                    <Column
                        header="N° Documento"
                        field="numeroDocumento"
                        style ={ {width: '80px'} }
                        filter filterElement={numeroDocumentoFilterElement}
                        body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.numeroDocumento, rowIndex)}                                          
                    />
                )
            // }
        }

        const renderHistoricoColumn = () => {
            // if(!this.props.isSearchByValue && !this.props.fromOFX){
            if(!this.props.fromOFX){
                return (
                    <Column
                        header="Histórico"
                        field="historico"
                        style ={ {width: '120px'} }
                        filter filterElement={historicoFilterElement}
                        body = { (rowData, rowIndex) => {

                            const uniqueId = `name_${rowIndex.rowIndex}`;
                            const historicoStyle = rowData.excluido ? {color: '#d32f2f'} : {}
                            const marcadorStyle = {
                                color: rowData.excluido ? '#d32f2f' : '#1976d2',
                                fontSize: '11px',
                                marginRight: '4px',
                                cursor: 'pointer'
                            }
                            //Só existe auditoria pra lançamento que já foi salvo (tem id)
                            const possuiAuditoria = rowData.idLancamentoFechamentoBancario ? true : false

                            return (

                                <div
                                    style ={ {
                                        // width: ConstantsUtil.widthColumNomeDreConsolidado,
                                        // maxHeight: '160px',
                                        overflow: 'hidden',
                                        // textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        // whiteSpace: 'normal',
                                        // whiteSpace: 'pre',
                                        // whiteSpace: 'pre-line',
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: possuiAuditoria ? 'pointer' : 'default'
                                    } }
                                    title={rowData.historico}
                                    onClick={() => this.showAuditoriaLancamentoBancario(rowData)}
                                >

                                    {/* o title do ícone sobrescreve o da div só quando o mouse está em cima dele;
                                        no resto da célula continua aparecendo o histórico completo */}
                                    {possuiAuditoria &&
                                        <i
                                            className="pi pi-history"
                                            title="Ver histórico de alterações"
                                            style={{color: '#9fb6cc', fontSize: '12px', marginRight: '6px', flexShrink: 0}}
                                        />
                                    }

                                    {rowData.excluido &&
                                        <span style={marcadorStyle}>(excluído)</span>
                                    }
                                    {!rowData.excluido && rowData.editado &&
                                        <span style={marcadorStyle}>(editado)</span>
                                    }

                                    <span id={uniqueId} style={historicoStyle}>{rowData.historico}</span>

                                </div>
                            )
                        }}
                    />
                )
            }
        }

        const renderContaBancariaColumn = () => {
            if(this.props.isSearchByValue || this.props.DRE || this.props.pesquisarTodasContasBancarias){
                return (
                    <Column
                        header={this.props.pesquisarTodasContasBancarias ? "Conta Bancária" : "Conta Bancária/Aplicação Financeira"}
                        field="contaBancariaOuAplicacaoFinanceiraLabel"
                        style ={ {width: '200px'} }
                        filter filterElement={contaBancariaOuAplicacaoFinanceiraFilterElement}
                    />
                )
            }
        }

        const renderConciliacaoColumn = () => {
            if(AuthService.verificaConfiguracao(ConstantsUtil.APRESENTA_CONCILIACAO)){
                return(
                    <Column
                        header="Conciliação"
                        style={{ width: '80px', textAlign: 'center' }}
                        body={rowData => rowData.conciliacaoBancaria
                            ? <i className="pi pi-check-circle" style={{ color: '#22c55e', fontSize: '1.2rem' }} />
                            : <i className="pi pi-times-circle" style={{ color: '#ef4444', fontSize: '1.2rem' }} />
                        }
                    />
                )
            }
        }

        const renderEntradaColumn = () => {
            if(!this.props.DRE || (this.props.DRE && (this.props.DRE_RECEBIMENTO || this.props.diferencaDRE) ) ){
                return(
                    <Column field="entrada" header="Entrada"  style ={ {width: '80px'} }
                        filter filterElement={entradaFilterElement}
                        body = {rowData => GeneralServices.showFormattedIfNonZero(rowData.entrada, true) }
                    />
                )
            }
        }

        const renderSaidaColumn = () => {
            if(!this.props.DRE || (this.props.DRE && (!this.props.DRE_RECEBIMENTO || this.props.diferencaDRE) ) ){
                return(
                    <Column field="saida" header="Saída"  style ={ {width: '80px'} }
                        filter filterElement={saidaFilterElement}
                        body = {rowData => GeneralServices.showFormattedIfNonZero(rowData.saida, true) }
                    />
                )
            }
        }

        const renderContaBancariaHeader = () => {
            if(!this.props.DRE && !this.props.isSearchByValue && !this.props.fromOFX && !this.props.pesquisarTodasContasBancarias) {
                return (
                <div className='col-md-6'>
                    <h5 
                        className='medium-font-size'
                        style={{ height: '20px' }}
                    >
                        {this.getTableHeaders().contaBancaria}
                    </h5>
                </div>
                )
            }
        }

        const renderPeriodoHeader = () => {
            if(!this.props.isSearchByValue && !this.props.fromOFX){
                return (
                    <div className='col-md-4'>
                        <h5 className='medium-font-size'>{this.getTableHeaders().periodo}</h5>
                    </div>                    
                )
            }
        }

        const renderSpace = () => {
            if(this.props.DRE){
                return (
                    <div className='col-md-6'>
                    </div>
                )
            }
        }

        const renderExport = () => {
            if(!this.props.fromOFX){
                return (
                    <>
                    {renderSpace()}
                    <div className='col-md-2'>
                        <Button label="Exportar" icon="pi pi-file-excel" className="p-button-success small-font"
                            tooltip={ConstantsUtil.exportXlsxLabel}
                            tooltipOptions={{position: 'top'}}
                            style={{maxHeight: '25px'}}
                            onClick={this.exportExcel}
                            disabled={!this.props.fichaBancaria || !this.props.fichaBancaria.fichaBancariaList}
                        />
                    </div> 
                    </>
                )
            }
        }

        const renderAcoesEmLoteButtons = () => {
            if(this.props.fromOFX || this.props.fromFichaBancaria){
                return (
                    <>
                        <div>
                            <Button
                                className="p-button-primary"
                                label="Edição em Lote"
                                icon="pi pi-pencil"
                                onClick={this.editLancamentosEmLote}
                            />
                        </div>
                        <div>
                            <Button
                                className="p-button-danger"
                                label="Exclusão em Lote"
                                icon="pi pi-times"
                                onClick={this.exclusaoEmLote}
                            />
                        </div>
                    </>
                )
            }
        }

        const renderExibirLancamentosExcluidosSwitch = () => {
            if(this.props.fromOFX){
                return
            }

            return (
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <span className="small-font">Exibir lançamentos excluídos</span>
                    <InputSwitch
                        checked={this.state.exibirLancamentosExcluidos}
                        onChange={(e) => this.setState({exibirLancamentosExcluidos: e.value})}
                    />
                </div>
            )
        }

        const renderTotalButtons = () => {
            return (
                <>
                    <div className="card mb-3">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <div>
                                <Button
                                    className="p-button-success"
                                    label={'Valor Total Entrada: ' + this.getTotalValue().entrada}
                                />
                            </div>
                            <div>
                                <Button
                                    className="p-button-danger"
                                    label={'Valor Total Saída: ' + this.getTotalValue().saida}
                                />
                            </div>
                            {renderExibirLancamentosExcluidosSwitch()}
                            {renderAcoesEmLoteButtons()}
                        </div>
                    </div>
                </>
            );
        };

        const renderHeader = () => {
            if(!this.props.isSearchByValue){
                return(
                    <>
                    <div className = "card-header">
                    <div className='col-md-12'>
                        <div className='row'>

                            {renderContaBancariaHeader()}

                            {renderPeriodoHeader()}

                            {renderExport()}

                        </div>
                        
                    </div>
                    </div>                
                    </>
                )
            }
        }

        const dataFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedData,
            this.getList(),
            "selectedData",
            (name, value) => this.setState({[name]: value}),
            'data',
            '80px',
            "Data"
        )         

        const descricaoOFXFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDescricaoOFX,
            this.getList(),
            "selectedDescricaoOFX",
            (name, value) => this.setState({[name]: value}),
            'descricaoOFX',
            '160px',
            "Descrição"
        )     

        const descricaoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedDescricao,
            this.getList(),
            "selectedDescricao",
            (name, value) => this.setState({[name]: value}),
            'descricao',
            '160px',
            "Recebimento/Pagamento"
        )         

        const grupoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedgrupo,
            this.getList(),
            "selectedgrupo",
            (name, value) => this.setState({[name]: value}),
            'grupo',
            '100%',
            "Grupo"
        )         

        const entradaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedEntrada,
            this.getList(),
            "selectedEntrada",
            (name, value) => this.setState({[name]: value}),
            'entrada',
            '80px',
            "Entrada"
        )         

        const saidaFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedSaida,
            this.getList(),
            "selectedSaida",
            (name, value) => this.setState({[name]: value}),
            'saida',
            '80px',
            "Saída"
        )         

        const historicoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedHistorico,
            this.getList(),
            "selectedHistorico",
            (name, value) => this.setState({[name]: value}),
            'historico',
            // 'historico',
            '200px',
            "Histórico"
        )         
        const numeroDocumentoFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedNumeroDocumento,
            this.getList(),
            "selectedNumeroDocumento",
            (name, value) => this.setState({[name]: value}),
            'numeroDocumento',
            // 'historico',
            '100%',
            "N° Documento"
        ) 

        const contaBancariaOuAplicacaoFinanceiraFilterElement = this.tableFilters.renderTableFilter(
            this.dt,
            this.state.selectedContaBancariaOuAplicacaoFinanceiraLabel,
            this.getList(),
            "selectedContaBancariaOuAplicacaoFinanceiraLabel",
            (name, value) => this.setState({[name]: value}),
            'contaBancariaOuAplicacaoFinanceiraLabel',
            '200px',
            this.props.pesquisarTodasContasBancarias ? "Conta Bancária" : "Conta Bancária/Aplicação Financeira"
        )
        
        const renderMultiSelectColumn = () => {
            if(this.props.fromOFX || this.props.fromFichaBancaria){
                return (
                    <Column selectionMode="multiple" headerStyle={{ width: '50px' }}/>
                )
            }
        }


        return (
            <>

            {renderTotalButtons()}

            {renderHeader()}

            <DataTable
                ref={this.dt}
                value={this.getList()}
                className="p-datatable-sm small-font"
                rowClassName={this.rowClass}
                rowHover
                showGridlines
                selectionMode="checkbox"
                selection={this.state.selectedLancamentosBancarios}
                onSelectionChange={this.handleSelectionChange}
                onValueChange={this.onTableListChange}
                scrollable
                scrollHeight={ this.props.insideDialog ? '350px' : "500px"}
                loading={this.props.loading || this.state.loading}
                dataKey="index"
                isDataSelectable={(rowData) => !rowData.excluido}
                emptyMessage="Nenhum Lançamento de Fechamento Bancário encontrado."
                paginator rows={ConstantsUtil.initialTableQuantityOption}
                paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, this.getList().length)}
                currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} lançamentos"
            >
            
            {renderMultiSelectColumn()}

            <Column field="data" header="Data" style ={ {width: '80px'} }
                filter filterElement={dataFilterElement}
            />

            {renderDescricaoOFXColumn()}

            <Column
                header={this.props.fromOFX ? "Tipo de Recebimento/Pagamento" : "Descrição"}
                field="descricao" style ={ {width: '160px'} }
                filter filterElement={descricaoFilterElement}
                body = {renderDescricaoColumnBody}
            />

            {renderGrupoColumn()}

            {renderEntradaColumn()}

            {renderSaidaColumn()}

            {renderSaldoColumn()}

            {renderHistoricoColumn()}

            {renderNumeroDocumentoColumn()}

            {renderContaBancariaColumn()}

            {renderConciliacaoColumn()}

            {renderActionColumn()}
            
            </DataTable>

            <EditLancamentoBancarioDialog  
                hideDialog={this.hideDialog}
                visible={this.state.editLancamentoBancarioDialog}
                header={this.state.editLancamentoBancarioDialogHeader}
                state={this.state.lancamentoToEdit}
                tipoDeRecebimentoList={this.props.tipoDeRecebimentoList}
                tipoDePagamentoList={this.props.fichaBancaria ? this.props.fichaBancaria.tipoDePagamentoList : []}
                idSelectedContaBancaria={this.props.fichaBancaria ? this.props.fichaBancaria.idContaBancaria : null}
                search={this.props.search}
                beginLoadingFichaBancariaTable={this.beginLoadingFichaBancariaTable}
                endLoadingFichaBancariaTable={this.endLoadingFichaBancariaTable}
                fromOFX={this.props.fromOFX}
                fromFichaBancaria={this.props.fromFichaBancaria}
                editLancamentoFromOFX={this.props.editLancamentoFromOFX}
                onFinishSearchTipoDePagamentoList={this.props.onFinishSearchTipoDePagamentoList}
                editLancamentosEmLoteFromOFX={this.props.editLancamentosEmLoteFromOFX}
                edicaoEmLote={this.state.edicaoEmLote}
                lancamentosSelecionados={this.state.selectedLancamentosBancarios}

                // disabled={true}
            />

            <Dialog header="Excluir Lançamento"
                visible={this.state.displayDeleteConfirmation}
                modal = {true} //congela restante da tela
                style={{ width: '350px' }}
                footer={renderDeleteConfirmationFooter()}
                onHide={this.cancelDelete}>
                <div className="confirmation-content row" style={{marginLeft: '10px'}}>
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem', marginRight: '10px'}} />
                    <div style={{marginBottom: '10px'}}> Deseja confirmar? </div>
                </div>
            </Dialog>

            <Dialog
                header="Histórico"
                visible={this.state.auditoriaDialog}
                modal={true}
                style={{ width: '82vw', maxWidth: '1100px' }}
                footer={this.renderAuditoriaDialogFooter()}
                onHide={() => this.setState({auditoriaDialog: false, auditoriaList: []})}
            >
                {this.renderAuditoriaTimeline()}
            </Dialog>

            </>
        )
    }

}

export default FichaBancariaTable
